// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3WkvK","list":"PatternAutocomplete_list__2Dg-y"};